import CreateGroupModal from './CreateGroupModal'
export default CreateGroupModal
